import { api } from '@api/api2';

export const getTicketClasses = () => api.v1('get', 'tck/classes/list');
